import React, { useEffect, useState } from 'react';

import '@syncfusion/ej2-react-inplace-editor/styles/inplace-editor/material.css';
import { Query } from '@syncfusion/ej2-data';
import { FilteringEventArgs } from '@syncfusion/ej2-react-dropdowns';
import {
    SelectEventArgs,
    SortOrder,
    TabComponent,
    TabItemDirective,
    TabItemsDirective,
} from '@syncfusion/ej2-react-navigations';
import { AxiosError } from 'axios';
import { useForm } from 'react-hook-form';

import 'components/ProviderData/IpaAdministration/organisms/IpaAdministration.css';

import { useToast, useUserGroups } from '@hooks';
import { requests } from 'common/axios';
import { tabDefaultSettings } from 'common/syncfusionConfigurations';
import { getItems } from 'components/AvaEzm/Utilities/ODataUtility';
import { IpaAdminTabId } from 'components/ProviderData/IpaAdministration/atoms/enums';
import { IPA } from 'components/ProviderData/IpaAdministration/atoms/Models';
import {
    createIpaMember,
    showConfirmation,
    permissionLevels,
} from 'components/ProviderData/IpaAdministration/atoms/utils';
import AdditionalContactTab from 'components/ProviderData/IpaAdministration/organisms/AdditionalContact/AdditionalContactTab';
import CapRatesTab from 'components/ProviderData/IpaAdministration/organisms/CapRates/CapRatesTab';
import ClaimDepartmentTab from 'components/ProviderData/IpaAdministration/organisms/ClaimDepartment/ClaimDepartmentTab';
import IpaCountyMappingTab from 'components/ProviderData/IpaAdministration/organisms/CountyMapping/IpaCountyMappingTab';
import DOFRContract from 'components/ProviderData/IpaAdministration/organisms/DOFR/DOFRContractTab';
import GainShareRatesTab from 'components/ProviderData/IpaAdministration/organisms/GainShareRates/GainShareRatesTab';
import styles from 'components/ProviderData/IpaAdministration/organisms/IpaAdministrationDetailView/IpaAdministrationDetailView.module.css';
import IPADetail from 'components/ProviderData/IpaAdministration/organisms/IpaAdministrationDetailView/IpaAdministrationDetailViewIPADetail';
import LeftHandCard from 'components/ProviderData/IpaAdministration/organisms/IpaAdministrationDetailView/IpaAdministrationDetailViewLeftHandCard';
import IpaHospitalTab from 'components/ProviderData/IpaAdministration/organisms/IpaHospital/IpaHospitalTab';
import IpaNetworkMappingTab from 'components/ProviderData/IpaAdministration/organisms/IpaNetworkMapping/IpaNetworkMappingTab';
import IpaPlanMappingTab from 'components/ProviderData/IpaAdministration/organisms/PlanMapping/IpaPlanMappingTab';
import PreferredStatusTab from 'components/ProviderData/IpaAdministration/organisms/PreferredStatus/PreferredStatusTab';
import RiskPoolRatesTab from 'components/ProviderData/IpaAdministration/organisms/RiskPoolRates/RiskPoolRatesTab';
import {
    refreshTabService,
    refreshIpaFiltersService,
    selectedTabIdService,
} from 'components/ProviderData/subjects/IpaAdministrationService';
import { tabService } from 'subjects/common/tabService';

type IpaAdministrationDetailViewProps = {
    tabId: number;
    ipaId: number;
    ipaCode: string;
    children?: React.ReactNode;
};

function IpaAdministrationDetailView(props: IpaAdministrationDetailViewProps) {
    const { ipaId, ipaCode } = props;
    const [ipa, setIpa] = useState<any>({});
    const [ipaDates, setIpaDates] = useState<any>({});
    const [companyCodes, setCompanyCodes] = useState<string[]>([]);
    const [mso, setMso] = useState<any>({});
    const [contracts, setContracts] = useState<any[]>([]);
    const [vendors, setVendors] = useState<any[]>([]);
    const [risks, setRisks] = useState<any[]>([]);
    const [types, setTypes] = useState<any[]>([]);
    const [loading, setLoading] = useState<boolean>();
    const [termed, setTermed] = useState<string>();
    const { showSuccessToast, showErrorToast } = useToast();
    const [editFlag] = useState(false);
    const [dofrFlag, setDofrFlag] = useState(false);
    const [countyFlag, setCountyFlag] = useState(false);
    const [riskFlag, setRiskFlag] = useState(false);
    const [gainShareFlag, setGainShareFlag] = useState(false);
    const [hospitalFlag, setHospitalFlag] = useState(false);
    const [networkMappingFlag, setNetworkMappingFlag] = useState(false);
    const [printMemberIdCardFlag, setPrintMemberIdCardFlag] = useState(false);
    const [preferredStatusFlag, setPreferredStatusFlag] = useState(false);
    const [isReadOnlyViewer, setIsReadOnlyViewer] = useState(false);
    const [claimDepartmentPermissions, setClaimDepartmentPermissions] = useState(permissionLevels.none);
    const { belongToGroupName } = useUserGroups();

    const {
        register: contractInfoForm,
        handleSubmit: onClickContractInfo,
        setValue: setContractInfoValue,
        getValues: getContractInfoValues,
        formState: { errors, isDirty },
    } = useForm<IPA>();
    const fields: object = { text: 'vendorId', value: 'vendorId' };
    let query: Query = new Query().select(['vendorId', 'vendorId']).take(50);
    const sortOrder: SortOrder = 'Ascending';

    const fetchTabFeatureFlags = async () => {
        const flags: any = await getItems<any>('/api/MedicalGroup/GetNetworkAdminFeatureFlags');
        const _dofrFlag = flags.find((f) => f.name === 'enable-dofr-tab');
        const _countyFlag = flags.find((f) => f.name === 'enable-county-mapping-tab');
        const _riskPoolFlag = flags.find((f) => f.name === 'enable-risk-pool-tab');
        const _gainShareFlag = flags.find((f) => f.name === 'enable-gain-share-tab');
        const _hospitalFlag = flags.find((f) => f.name === 'enable-hospital-tab');
        const _networkMappingFlag = flags.find((f) => f.name === 'enable-network-mapping-tab');
        const _printMemberIdCard = flags.find((f) => f.name === 'enable-print-member-id-card');
        const _preferredStatusFlag = flags.find((f) => f.name === 'enable-preferred-status-tab');
        setDofrFlag(_dofrFlag?.isActive);
        setCountyFlag(_countyFlag?.isActive);
        setRiskFlag(_riskPoolFlag?.isActive);
        setGainShareFlag(_gainShareFlag?.isActive);
        setHospitalFlag(_hospitalFlag?.isActive);
        setNetworkMappingFlag(_networkMappingFlag?.isActive);
        setPrintMemberIdCardFlag(_printMemberIdCard?.isActive);
        setPreferredStatusFlag(_preferredStatusFlag?.isActive);
    };

    const fetchCompanyCodes = async () => {
        const _companyCodes = await getItems<string>('/api/MedicalGroup/GetCompanyCodes');
        setCompanyCodes(_companyCodes);
    };

    const fetchMso = async (contractId) => {
        if (!contractId && !ipa.contractLevelId) return;

        let _mso: any = {};
        _mso = await getItems<string>(
            `/api/MedicalGroup/GetMsoDetails?contractId=${contractId || ipa.contractLevelId}`,
        );
        setMso(_mso);
        for (const m in _mso) {
            const field = m.charAt(0).toUpperCase() + m.slice(1);
            setContractInfoValue(('mso' + field) as keyof IPA, _mso[field]);
        }
        setTermed(_mso.isTermed);
    };

    const fetchContracts = async () => {
        let _contracts: any = [];
        _contracts = await getItems<string>(`/api/MedicalGroup/GetAllIpaContracts`);
        setContracts(_contracts);
    };

    const fetchIpaEffDateAndEndDat = async (ipaCode) => {
        if (ipaCode) {
            requests.get(`/api/MedicalGroup/GetIpaEffDateAndEndDate?ipaCode=${ipaCode}`).then((_ipaDates: any) => {
                if (_ipaDates) {
                    setIpaDates(_ipaDates);
                    setLoading(false);
                }
            });
        } else {
            setLoading(false);
        }
    };

    const fetchVendors = async () => {
        let _vendors: any = [];
        _vendors = await getItems<any>(`/api/MedicalGroup/GetVendorID/`);
        setVendors(_vendors);
    };

    const fetchRisks = async () => {
        let _risks: any = [];
        _risks = await getItems<string>(`/api/MedicalGroup/GetIpaRisks`);
        setRisks(_risks);
    };

    const fetchTypes = async () => {
        let _types: any = [];
        _types = await getItems<string>(`/api/MedicalGroup/GetIpaTypes`);
        setTypes(_types);
    };

    if (ipa?.vendorId) {
        const filteredVendors = new Query()
            .where('vendorId', 'startswith', ipa?.vendorId.slice(0, ipa?.vendorId.length / 2), true)
            .select(['vendorId', 'vendorId'])
            .take(50);
        if (filteredVendors) {
            query = filteredVendors;
        }
    }

    function onFiltering(e: FilteringEventArgs) {
        if (e.text === '') {
            e.updateData(vendors);
        } else {
            if (e.text.length < 1) {
                return;
            }
            let query: Query = new Query().select(['vendorId', 'vendorId']);
            query = e.text !== '' ? query.where('vendorId', 'startswith', e.text, true) : query;
            e.updateData(vendors, query);
        }
    }

    const saveContractInformation = async (data: IPA) => {
        //if (!data.npi) {
        //    showSuccessToast("NPI is Empty. Please select Different Vendor Id")
        //}
        //if (!data.taxId) {
        //    showSuccessToast("TaxId is Empty. Please select Different Vendor Id")
        //}
        try {
            let action = 'AddNewIpa';
            const effDt = new Date(data.effDate);
            const endDt = new Date(data.endDate);
            data.effDate = `${effDt.getMonth() + 1}/${effDt.getDate()}/${effDt.getFullYear()}`;
            data.endDate = `${endDt.getMonth() + 1}/${endDt.getDate()}/${endDt.getFullYear()}`;
            const adaptedData = {
                ...data,
            };
            for (const d in adaptedData) {
                if (d.includes('mso')) {
                    delete adaptedData[d];
                }
            }
            if (ipa.id) {
                action = 'UpdateIpa';
                adaptedData.id = ipa.id;
            }
            const url = `/api/MedicalGroup/${action}`;
            if (action === 'AddNewIpa') adaptedData.companyCode = undefined;
            await requests.post(url, adaptedData);
            showSuccessToast(`IPA ${ipa.id ? 'Updated' : 'Created'} Successfully`);
            if (printMemberIdCardFlag) await checkMemberCardInformation(adaptedData);
            tabService.close();
            refreshTabService.performAction('refresh');
            refreshIpaFiltersService.refresh();
        } catch (e) {
            const message = `${(e as AxiosError)?.response?.data}`;
            showErrorToast('Error :', message);
        }
    };

    const checkMemberCardInformation = async (data: IPA) => {
        if (data.ipaPhoneIdCard !== ipa.ipaPhoneIdCard || data.ipaNameIdCard !== ipa.ipaNameIdCard) {
            const shouldCreateWorkflow = await showConfirmation({
                title: 'Creating Workflow',
                message: `<div>
                        <div>You have made changes to one or more of the following fields:</div>
                        <br />
                        <ul>
                            <li><b>Member Card/IPA Name</b></li>
                            <li><b>Member Card/IPA Phone</b></li>
                        </ul>
                        <div>Do you want to create a workflow for <i>PrintMemberIdCard</i>?</div>
                    </div>`,
            });
            if (shouldCreateWorkflow) {
                const url = '/api/PrintMemberIdCardWorkflow/CreateWorkflow';
                setLoading(true);
                try {
                    await requests.post(url, { ipaCode: data.ipaCode });
                    showSuccessToast('PrintMemberIdCard Workflow created');
                } catch (error) {
                    console.error(error);
                    showErrorToast('Failed to create PrintMemberIdCard Workflow');
                } finally {
                    setLoading(false);
                }
            }
        }
    };

    const copyToNewRecord = () => {
        createIpaMember(ipaId, true);
    };

    useEffect(() => {
        const controller = new AbortController();
        setLoading(true);
        Promise.all([
            fetchVendors(),
            fetchCompanyCodes(),
            fetchRisks(),
            fetchTypes(),
            fetchContracts(),
            fetchTabFeatureFlags(),
        ]).finally(() => {
            setLoading(false);
        });

        return () => {
            controller.abort();
        };
    }, []);

    useEffect(() => {
        if (belongToGroupName('Provider Data Viewers') && !belongToGroupName('Provider Network Manager'))
            setIsReadOnlyViewer(true);

        if (belongToGroupName('Provider Data Manager - Claim Department')) {
            setClaimDepartmentPermissions(permissionLevels.edit);
        } else if (belongToGroupName('Provider Data Viewers') || belongToGroupName('Provider Network Manager')) {
            setClaimDepartmentPermissions(permissionLevels.readOnly);
        } else {
            setClaimDepartmentPermissions(permissionLevels.none);
        }
    }, [belongToGroupName]);

    useEffect(() => {
        const controller = new AbortController();
        if (companyCodes.length && risks.length && types.length) {
            if (ipaId) {
                requests.get(`/api/MedicalGroup/GetDetailByIpaId?ipaId=${ipaId}`).then((_ipa: any) => {
                    if (_ipa) {
                        setIpa(_ipa);
                        for (const field in _ipa) {
                            setContractInfoValue(field as keyof IPA, _ipa[field]);
                        }
                        setContractInfoValue('npi', _ipa.vendorNpi || _ipa.npi);
                        setContractInfoValue('effDate', _ipa.effDate);
                        setContractInfoValue('endDate', _ipa.endDate);
                        fetchIpaEffDateAndEndDat(_ipa.ipaCode);
                        setLoading(false);
                    }
                });
            } else {
                setLoading(false);
            }
        }
        return () => {
            controller.abort();
        };
    }, [companyCodes, risks, types, ipaId]);

    return (
        <div className={`${styles['medical-group-admin-container']} tabDiv medical-group-admin`}>
            <div className={`${styles['header-content']} header-content`}>
                {!loading ? (
                    <>
                        <div className='gridHeaderDiv dark blue-border no-top-border'>
                            <div className='card-title-item'>
                                <b>IPA Desc: </b>
                                {ipa.ipaDesc}
                            </div>
                            <div className='card-title-item'>
                                <b>FACETS Code: </b>
                                {ipa.facetsCode}
                            </div>
                            <div className='card-title-item'>
                                <b>NPI: </b>
                                {ipa.npi}
                            </div>
                            <div className='card-title-item'>
                                <b>Tax ID: </b>
                                {ipa.taxId}
                            </div>
                        </div>
                        <div className='row mt-3 m-2'>
                            <div className='col-md-3'>
                                <div className='leftContainer'>
                                    <LeftHandCard
                                        mso={mso}
                                        ipa={ipa}
                                    />
                                </div>
                            </div>
                            <div className='col-md-9'>
                                <div className='rightContainer p-3'>
                                    <TabComponent
                                        {...tabDefaultSettings}
                                        heightAdjustMode='Auto'
                                        id='defaultTab'
                                        selected={({ selectedItem }: SelectEventArgs) => {
                                            selectedTabIdService.set({
                                                ipaId: ipa.id,
                                                tabId: selectedItem?.getAttribute('data-id') || '',
                                            });
                                        }}
                                    >
                                        {ipa.id && (
                                            <TabItemsDirective>
                                                <TabItemDirective
                                                    header={{ text: 'IPA Details' }}
                                                    content={() => (
                                                        <IPADetail
                                                            ipa={ipa}
                                                            setIpa={setIpa}
                                                            mso={mso}
                                                            contractInfoForm={contractInfoForm}
                                                            getContractInfoValues={getContractInfoValues}
                                                            setContractInfoValue={setContractInfoValue}
                                                            editFlag={editFlag}
                                                            errors={errors}
                                                            risks={risks}
                                                            types={types}
                                                            isReadOnlyViewer={isReadOnlyViewer}
                                                            onClickContractInfo={onClickContractInfo}
                                                            saveContractInformation={saveContractInformation}
                                                            contracts={contracts}
                                                            onFiltering={onFiltering}
                                                            sortOrder={sortOrder}
                                                            query={query}
                                                            vendors={vendors}
                                                            fields={fields}
                                                            fetchContracts={fetchContracts}
                                                            fetchMso={fetchMso}
                                                            companyCodes={companyCodes}
                                                            termed={termed}
                                                            copyToNewRecord={copyToNewRecord}
                                                            isDirty={isDirty}
                                                        />
                                                    )}
                                                />
                                                <TabItemDirective
                                                    header={{ text: 'Additional Contact' }}
                                                    content={() => (
                                                        <AdditionalContactTab
                                                            id={ipaId}
                                                            isReadOnlyViewer={isReadOnlyViewer}
                                                            risk={ipa.risk}
                                                            ipaCode={ipaCode}
                                                        />
                                                    )}
                                                />
                                                <TabItemDirective
                                                    header={{ text: 'Claim Info' }}
                                                    content={() => (
                                                        <ClaimDepartmentTab
                                                            id={ipaId}
                                                            claimDepartmentPermissions={claimDepartmentPermissions}
                                                            risk={ipa.risk}
                                                            ipaCode={ipaCode}
                                                            printMemberIdCardFlag={printMemberIdCardFlag}
                                                        />
                                                    )}
                                                />
                                                {networkMappingFlag && (
                                                    <TabItemDirective
                                                        header={{ text: 'Network & Agreement' }}
                                                        content={() => (
                                                            <IpaNetworkMappingTab
                                                                ipa={ipa}
                                                                isReadOnlyViewer={isReadOnlyViewer}
                                                            />
                                                        )}
                                                    />
                                                )}
                                                {preferredStatusFlag && (
                                                    <TabItemDirective
                                                        id={IpaAdminTabId.PreferredStatus}
                                                        header={{ text: 'Preferred Status' }}
                                                        content={() => <PreferredStatusTab ipa={ipa} />}
                                                    />
                                                )}
                                                <TabItemDirective
                                                    header={{ text: 'PBP Map' }}
                                                    content={() => (
                                                        <IpaPlanMappingTab
                                                            companyCode={ipa.companyCode}
                                                            ipaId={ipaId}
                                                            ipaCode={ipaCode}
                                                            isReadOnlyViewer={isReadOnlyViewer}
                                                        />
                                                    )}
                                                />
                                                {countyFlag && (
                                                    <TabItemDirective
                                                        header={{ text: 'County Map' }}
                                                        content={() => (
                                                            <IpaCountyMappingTab
                                                                companyCode={ipa.companyCode}
                                                                ipaId={ipaId}
                                                                ipaCode={ipaCode}
                                                                isReadOnlyViewer={isReadOnlyViewer}
                                                                state={ipa.state}
                                                            />
                                                        )}
                                                    />
                                                )}
                                                <TabItemDirective
                                                    header={{ text: 'Cap Rates' }}
                                                    content={() => (
                                                        <CapRatesTab
                                                            ipa={ipa}
                                                            ipaDates={ipaDates}
                                                            ipaId={ipaId}
                                                            ipaCode={ipaCode}
                                                            isReadOnlyViewer={isReadOnlyViewer}
                                                        />
                                                    )}
                                                />
                                                {riskFlag && (
                                                    <TabItemDirective
                                                        header={{ text: 'Risk Pool Rates' }}
                                                        content={() => (
                                                            <RiskPoolRatesTab
                                                                ipa={ipa}
                                                                ipaId={ipaId}
                                                                ipaCode={ipaCode}
                                                                isReadOnlyViewer={isReadOnlyViewer}
                                                            />
                                                        )}
                                                    />
                                                )}
                                                {gainShareFlag && (
                                                    <TabItemDirective
                                                        header={{ text: 'Gain Share Rates' }}
                                                        content={() => (
                                                            <GainShareRatesTab
                                                                ipa={ipa}
                                                                ipaId={ipaId}
                                                                ipaCode={ipaCode}
                                                                isReadOnlyViewer={isReadOnlyViewer}
                                                            />
                                                        )}
                                                    />
                                                )}
                                                {hospitalFlag && (
                                                    <TabItemDirective
                                                        header={{ text: 'Hospital' }}
                                                        content={() => (
                                                            <IpaHospitalTab
                                                                ipa={ipaCode}
                                                                companyId={ipa.companyCode}
                                                            />
                                                        )}
                                                    />
                                                )}
                                                {dofrFlag && (
                                                    <TabItemDirective
                                                        header={{ text: 'DOFR' }}
                                                        content={() => (
                                                            <DOFRContract
                                                                ipa={ipa}
                                                                isReadOnlyViewer={isReadOnlyViewer}
                                                            />
                                                        )}
                                                    />
                                                )}
                                            </TabItemsDirective>
                                        )}
                                    </TabComponent>
                                </div>
                            </div>
                        </div>
                    </>
                ) : (
                    <>
                        <div>
                            <div className={styles['spinner-content']}></div>
                            <div className={`${styles['spinner']} spinner-border`}></div>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
}

export default React.memo(IpaAdministrationDetailView);
